// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xg4lE0gJWLIm3eq6enFW{flex-direction:column;align-items:flex-start;gap:12px;display:flex}.HLCmgSZtyfUhIWAoht4h{white-space:nowrap}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `Xg4lE0gJWLIm3eq6enFW`,
	"alertButton": `HLCmgSZtyfUhIWAoht4h`
};
export default ___CSS_LOADER_EXPORT___;
